import React from "react";

export default function MSAccess_InStrRev() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">MSAccess_InStrRev</h1>
      <p>This is the MSAccess_InStrRev component generated from the SQL JSON.</p>
    </div>
  );
}
